; if (typeof culture == "undefined") culture = 'en-US';

Number.prototype.formatMoney = function (c, d, t) {
    var n = this, c = isNaN(c = Math.abs(c)) ? 2 : c, d = d == undefined ? "," : d, t = t == undefined ? "." : t, s = n < 0 ? "-" : "", i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

for (var i = 7; i >= 0; i--) {
    Number.prototype['formatNumber' + (i || '')] = function () {
        var option = {
            minimumFractionDigits: i,
            maximumFractionDigits: i,
            style: 'decimal'
        };
        return function (_culture) {
            return this.toLocaleString(_culture || culture, option);
        };
    }();
}

Number.prototype.toPercent = function (_culture) {
    return (this * 100).formatNumber2(_culture);
};

Number.prototype.toUsdNoCent = (function () {
    var option = {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: 'currency',
        currency: "USD"
    };
    return function (_culture) {
        var c = _culture || culture;
        c = c.indexOf('en') == 0 ? 'en' : c;
        return this.toLocaleString(c, option);
    };
})();

Number.prototype.toUsd = (function () {
    var option = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'currency',
        currency: "USD"
    };
    return function (_culture) {
        var c = _culture || culture;
        c = c.indexOf('en') == 0 ? 'en' : c;
        return this.toLocaleString(c, option);
    };
})();

Number.prototype.formatPercentFull = function (_culture) {
    return (this > 0 ?
        "+" : this < 0 ?
            "-" : "") + (Math.abs(this).formatPercent(_culture));
};

Number.prototype.formatPercent = function () {
    var option = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'percent'
    };
    return function (_culture) {
        return this.toLocaleString(_culture || culture, option);
    };
}();

Number.prototype.formatIntPercent = function () {
    var option = {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: 'percent'
    };
    return function (_culture) {
        return this.toLocaleString(_culture || culture, option);
    };
}();